// services.js
import api from './api';

// Read this at request time: this module loads before sign-in in some flows.
const getUserId = () => localStorage.getItem('userId');

// ---------------------- WALLET API ----------------------
export const walletAPI = {
  // Fetch wallet balance
  getBalance: () => api.post(`/api/wallet/balance?user=${getUserId()}`).then(res => res.data),

  // Fetch transactions list
  getTransactions: (params = {}) =>
    api.post('/api/wallet/transactions', { ...params, userId: getUserId() })
      .then(res => res.data),

  // Deposit funds
  deposit: (data) =>
    api.post('/api/wallet/deposit', { ...data, userId: getUserId() })
      .then(res => res.data),

  // Withdraw funds
  withdraw: (data) =>
    api.post('/api/wallet/withdraw', { ...data, userId: getUserId() })
      .then(res => res.data),

  // Pay a provider
  payProvider: (data) =>
    api.post('/api/wallet/pay-provider', { ...data, userId: getUserId() })
      .then(res => res.data),

  

  // Get details for one transaction
  getTransactionDetails: (id) =>
    api.post(`/api/wallet/transactions/${getUserId()}`, { userId: getUserId() })
      .then(res => res.data),
//Externaltopup
  topup : (data)=>
    api.post(`/api/wallet/top-up`, data)
        .then(res=> res.data),

  addFundingSource: (data) =>
    api.post('/api/wallet/funding-source/add', { ...data, userId: getUserId() })
      .then(res => res.data),

  getFundingSourceStatus: (referenceId) =>
    api.get(`/api/wallet/funding-source/status/${encodeURIComponent(referenceId)}?userId=${getUserId()}`)
      .then(res => res.data),

  getFundingContext: () =>
    api.get(`/api/wallet/funding-source/context?userId=${getUserId()}`)
      .then(res => res.data),

  addEmployerSupportProfile: (data) =>
    api.post('/api/wallet/funding-source/employer/add', { ...data, userId: getUserId() })
      .then(res => res.data),

  redeemDonorVoucher: (data) =>
    api.post('/api/wallet/funding-source/voucher/redeem', { ...data, userId: getUserId() })
      .then(res => res.data),

  issueDonorVoucher: (data) =>
    api.post('/api/wallet/funding-source/voucher/issue', data)
      .then(res => res.data),

  payApprovedService: (data) =>
    api.post('/api/wallet/pay-approved-service', { ...data, userId: getUserId() })
      .then(res => res.data),

  getWalletAlerts: () =>
    api.get(`/api/wallet/alerts?userId=${getUserId()}`)
      .then(res => res.data),

  getCoverageEstimate: () =>
    api.post('/api/wallet/coverage-estimate', { userId: getUserId() })
      .then(res => res.data),

  getWalletSummary: () =>
    api.get(`/api/wallet/summary?userId=${getUserId()}`)
      .then(res => res.data),

  addDependent: (data) =>
    api.post('/api/wallet/dependents/add', { ...data, userId: getUserId() })
      .then(res => res.data),

  createDependentAllowance: (dependentId, data) =>
    api.post(`/api/wallet/dependents/${dependentId}/allowance`, { ...data, userId: getUserId() })
      .then(res => res.data),

  getDependents: () =>
    api.get(`/api/wallet/dependents?userId=${getUserId()}`)
      .then(res => res.data),

  getLinkedDependents: () =>
    api.get(`/api/wallet/dependents/linked-to-me?userId=${getUserId()}`)
      .then(res => res.data),

  removeDependent: (dependentId) =>
    api.delete(`/api/wallet/dependents/${dependentId}?userId=${getUserId()}`)
      .then(res => res.data),
};



// ---------------------- INSURANCE API ----------------------
export const insuranceAPI = {
  getPlans: () => api.get('/api/insurance/plans'),
  getPlanDetails: (id) => api.get(`/api/insurance/plans/${id}`),
  getSubscription: () => api.get(`/api/insurance/subscription?userId=${getUserId()}`),
  getSubscriptionReminders: () => api.get(`/api/insurance/subscription/reminders?userId=${getUserId()}`).then(res => res.data),
  subscribe: (data) => api.post(`/api/insurance/subscribe?userId=${getUserId()}`, data),
  cancelSubscription: () => api.post(`/api/insurance/subscription/cancel?user=${getUserId()}`),
  updateSubscription: (data) => api.put(`/api/insurance/subscription?userId=${getUserId()}`, data),
  submitClaim: (data) => api.post('/api/insurance/claims', data),
  getClaims: (params = {}) => api.get('/api/insurance/claims', { params }),
  getClaimDetails: (id) => api.get(`/api/insurance/claims/${id}`),
  cancelClaim: (id) => api.put(`/api/insurance/claims/${id}/cancel`),
  getCoverageDetails: () => api.get('/api/insurance/coverage'),
  checkServiceCoverage: (data) => api.post('/api/insurance/check-coverage', data),
  getEligibleServices: () => api.get('/api/insurance/coverage/eligible-services'),
};

// ---------------------- PROVIDERS API ----------------------
export const providersAPI = {
  getAll: (params = {}) => api.get('/api/providers', { params }),
  getById: (id) => api.get(`/api/providers/${id}`),
  search: (query) => api.get(`/api/providers/search/${query}`),
};

// ---------------------- BENEFITS API ----------------------
export const benefitsAPI = {
  getAll: () => api.get('/api/benefits'),
  getByProvider: (providerId) => api.get(`/api/benefits/provider/${providerId}`),
  getById: (id) => api.get(`/api/benefits/${id}`),
  apply: (data) => api.post('/api/benefits/apply', data),
  getActivePartners: () => api.get('/api/benefits/partners/active'),
};

// ---------------------- COMBINED EXPORT ----------------------
const Services = {
  wallet: walletAPI,
  insurance: insuranceAPI,
  providers: providersAPI,
  benefits: benefitsAPI,
};

export default Services;
